import axios from 'axios';

const SystemService = {
  async getDocumentTypes() {
    const response = await axios.get('/system/types');

    return response.data;
  },

  async getSignedUrlFromPath(path) {
    const response = await axios.get('/system/signed_url_from_path', {
      params: {
        path,
      },
    });

    return response.data;
  },
};

export default SystemService;
